import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";
import Drp_DocType from '../AccountDocType/Drp_DocType';
import Auto_SubLevelAccount1 from '../AccountSubLevelGroup/Auto_SubLevelAccount';
import Auto_SubLevelAccount2 from '../AccountSubLevelGroup/Auto_SubLevelAccount';
import Auto_SubLevelAccount3 from '../AccountSubLevelGroup/Auto_SubLevelAccount';
import Auto_ACCC from '../AccountDetail/Auto_ACCC';



const InsertDocIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DocTypeRef = useRef()
    const SubLevelAccount1Ref = useRef()
    const SubLevelAccount2Ref = useRef()
    const SubLevelAccount3Ref = useRef()
    const Auto_ACCCRef = useRef()

    const [ItemList, setItemList] = useState([]);
    const [HeaderId, setHeaderId] = useState(localStorage.getItem("DocHeaderId") == null ? General.GuidEmpty() : localStorage.getItem("DocHeaderId"));
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [SerialNo, setSerialNo] = useState(0);
    const [Number, setNumber] = useState(0);
    const [SystemNumber, setSystemNumber] = useState(0);
    const [State, setState] = useState("0");
    const [DocTypeId, setDocTypeId] = useState("-1");
    const [OrderShow, setOrderShow] = useState(0);


    const [TotalDebitPrice, setTotalDebitPrice] = useState(0);
    const [TotalCreditPrice, setTotalCreditPrice] = useState(0);

    const [Sub_Acc_LTitle1, setSub_Acc_LTitle1] = useState("");
    const [Sub_Acc_LTitle2, setSub_Acc_LTitle2] = useState("");
    const [Sub_Acc_LTitle3, setSub_Acc_LTitle3] = useState("");
    const [Acc_CRemain, setAcc_CRemain] = useState(0);
    const [Acc_CTitle, setAcc_CTitle] = useState("");
    const [Acc_GLRemain, setAcc_GLRemain] = useState(0);
    const [Acc_GLTitle, setAcc_GLTitle] = useState("");
    const [Acc_GRemain, setAcc_GRemain] = useState(0);
    const [Acc_GTitle, setAcc_GTitle] = useState("");
    const [RegisterDate, setRegisterDate] = useState(moment(new Date()));
    const [ReadOnlyRegisterDate, setReadOnlyRegisterDate] = useState("");
    const [Comment, setComment] = useState("");
    //#endregion



    const RegisterDate_Change = e => {
        // setItemList([]);
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setRegisterDate(moment(m, 'jYYYY/jMM/jDD'));
    }



    //#region Methods


    const GetById = (headerId) => {


        var RequestOptions = {
            data: {

            },
            url: General.ApiRoute() + "/Account_Doc/GetHeaderById",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Id': headerId,
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {

                    setRegisterDate(moment(result.data.registerDate, 'jYYYY/jMM/jDD'))
                    setReadOnlyRegisterDate(result.data.registerDate)
                    setNumber(result.data.number);
                    setState(result.data.state);
                    setSystemNumber(result.data.systemNumber);
                    setSerialNo(result.data.serialNo);
                    setComment(result.data.comment);
                    DocTypeRef.current.Bind(result.data.docTypeId);
                    if (result.data.children.length > 0) {
                        var tmp = [];

                        for (var i = 0; i < result.data.children.length; i++) {
                            console.dir(i)
                            console.dir(result.data.children[i].id)
                            tmp.push({
                                row: i + 1,
                                Editable: false,
                                Id: result.data.children[i].id,
                                DebitPrice: result.data.children[i].debitPrice,
                                CreditPrice: result.data.children[i].creditPrice,
                                Acc_CId: result.data.children[i].acc_CId,
                                Acc_CCode: result.data.children[i].acc_CCode,
                                Acc_CTitle: result.data.children[i].acc_CTitle,
                                Acc_CRemain: result.data.children[i].acc_CRemain,
                                Acc_GLId: result.data.children[i].acc_GLId,
                                Acc_GLCode: result.data.children[i].acc_GLCode,
                                Acc_GLTitle: result.data.children[i].acc_GLRemain,
                                Acc_GLRemain: result.data.children[i].acc_GLRemain,
                                Acc_GId: result.data.children[i].acc_GId,
                                Acc_GCode: result.data.children[i].acc_GCode,
                                Acc_GTitle: result.data.children[i].acc_GRemain,
                                Acc_GRemain: result.data.children[i].acc_GRemain,
                                Sub_Acc_Id3: result.data.children[i].sub_Acc_Id3,
                                Sub_Acc_L3: result.data.children[i].sub_Acc_L3,
                                Level3: result.data.children[i].level3,
                                Sub_Acc_LCode3: result.data.children[i].sub_Acc_LCode3,
                                Sub_Acc_LTitle3: result.data.children[i].sub_Acc_LTitle3,
                                Sub_Acc_LRemain3: result.data.children[i].sub_Acc_LRemain3,
                                Sub_Acc_Id2: result.data.children[i].sub_Acc_Id2,
                                Sub_Acc_L2: result.data.children[i].sub_Acc_L2,
                                Level2: result.data.children[i].level2,
                                Sub_Acc_LCode2: result.data.children[i].sub_Acc_LCode2,
                                Sub_Acc_LTitle2: result.data.children[i].sub_Acc_LTitle2,
                                Sub_Acc_LRemain2: result.data.children[i].sub_Acc_LRemain2,
                                Sub_Acc_Id1: result.data.children[i].sub_Acc_Id1,
                                Sub_Acc_L1: result.data.children[i].sub_Acc_L1,
                                Level1: result.data.children[i].level1,
                                Sub_Acc_LCode1: result.data.children[i].sub_Acc_LCode1,
                                Sub_Acc_LTitle1: result.data.children[i].sub_Acc_LTitle1,
                                Sub_Acc_LRemain1: result.data.children[i].sub_Acc_LRemain1,
                                Comment: result.data.children[i].comment,
                                Id: result.data.children[i].id,
                                status: "",
                                CreditPrice: result.data.children[i].creditPrice,
                                DebitPrice: result.data.children[i].debitPrice,
                                OrderShow: result.data.children[i].orderShow,


                            })
                        }
                        console.dir("test")
                        console.dir(tmp)
                        setDocTypeId(result.data.docTypeId);

                        setTimeout(() => {
                            setItemList(tmp)
                        }, 200)
                    }




                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )






    }

    const Reset = () => {
        const inputElement = document.querySelector('.FirstFocus');
        if (inputElement) {
            inputElement.focus();
        }
        setItemList([]);
        setHeaderId(General.GuidEmpty());
        setNumber(0);
        setSystemNumber(0);
        setSerialNo(0);
        setComment("");
        setRegisterDate(moment(new Date()));
        setReadOnlyRegisterDate("");
    }

    const Save = () => {


        if (RegisterDate == "" || RegisterDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ پیش فاکتور اجباری می باشد")), 'topCenter')
            return;
        }

        if (State == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن وضعیت اجباری می باشد")), 'topCenter')
            return;
        }

        if (ItemList.length == 0 || (ItemList.length == 1 && ItemList[0].status != "EDIT")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" لیست محصولات پیش فاکتور اجباری می باشد")), 'topCenter')
            return;
        }

        if (State == 1 && TotalCreditPrice != TotalDebitPrice) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(".سند طراز نمی باشد (بدهکار و بستانکاری سند برابر نمی باشد)، نمی توان سند را به صورت موقت ثبت کرد")), 'topCenter')
            return;
        }

        var RequestOptions = {
            data: {
                "Id": HeaderId,
                "Number": Number * 1,
                "Comment": Comment,
                "RegisterDate": moment(RegisterDate.format()).format('jYYYY/jMM/jDD'),
                "SaveType": 0,
                "State": State * 1,
                "DocTypeId": DocTypeId,
                "FiscalYearId": FiscalYearId,
                "Children": [...ItemList].filter(item => item.Acc_CId != General.GuidEmpty() && item.status != 'EDIT'),
            },
            url: General.ApiRoute() + "/Account_Doc/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("سند با موفقیت ثبت شده است - شماره سند : " + result.data.split("|")[1] + " شماره سریال سند : " + result.data.split("|")[2])), 'topCenter')


                        if (HeaderId == General.GuidEmpty()) {
                            Reset();
                            localStorage.removeItem("DocHeaderId");
                        }
                        else {
                            navigate("/DocIndex");
                            localStorage.removeItem("DocHeaderId");
                        }

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }

                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const onEditItem = (row) => {

        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            temp[index].status = "EDIT";
            temp[index].DebitPrice = PN.sliceNumber(temp[index].DebitPrice);
            temp[index].CreditPrice = PN.sliceNumber(temp[index].CreditPrice);

            setTimeout(() => {
                SubLevelAccount1Ref.current.SetEnable(temp[index].Level1 * 1)
                SubLevelAccount2Ref.current.SetEnable(temp[index].Level2 * 1)
                SubLevelAccount3Ref.current.SetEnable(temp[index].Level3 * 1)
            }, 200)

        }
        setItemList(temp);
    }

    const NewItem = () => {
        var temp = [...ItemList];
        setAcc_CTitle("")
        setAcc_GTitle("")
        setAcc_GTitle("")
        setSub_Acc_LTitle1("")
        setSub_Acc_LTitle2("")
        setSub_Acc_LTitle3("")
        var index = temp.findIndex(x => x.status == "EDIT");
        if (index == -1) {
            temp.push(
                {
                    row: ItemList.length + 1,
                    Acc_CId: General.GuidEmpty(),
                    Acc_CCode: '',
                    Acc_CTitle: '',
                    Acc_CRemain: 0,
                    Acc_GLId: General.GuidEmpty(),
                    Acc_GLCode: '',
                    Acc_GLTitle: '',
                    Acc_GLRemain: 0,
                    Acc_GId: General.GuidEmpty(),
                    Acc_GCode: '',
                    Acc_GTitle: '',
                    Acc_GRemain: 0,
                    Sub_Acc_Id3: General.GuidEmpty(),
                    Sub_Acc_L3: -1,
                    Level3: -1,
                    Sub_Acc_LCode3: '',
                    Sub_Acc_LTitle3: '',
                    Sub_Acc_LRemain3: 0,
                    Sub_Acc_Id2: General.GuidEmpty(),
                    Sub_Acc_L2: -1,
                    Level2: -1,
                    Sub_Acc_LCode2: '',
                    Sub_Acc_LTitle2: '',
                    Sub_Acc_LRemain2: 0,
                    Sub_Acc_Id1: General.GuidEmpty(),
                    Sub_Acc_L1: -1,
                    Level1: -1,
                    Sub_Acc_LCode1: '',
                    Sub_Acc_LTitle1: '',
                    Sub_Acc_LRemain1: 0,
                    Comment: Comment,
                    Id: General.GuidEmpty(),
                    status: "EDIT",
                    CreditPrice: 0,
                    DebitPrice: 0,
                    OrderShow: OrderShow * 1 + 1,
                });
            setItemList(temp)
            setTimeout(() => {
                Auto_ACCCRef.current.focus();
                // const inputElement = document.querySelector('.FocusItem');
                // if (inputElement) {
                //     inputElement.focus();
                // }

            }, 200)

        }
    }

    const Change_Item = (row, dataType, value, text = "") => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (dataType == "DebitPrice") {
                var price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                temp[index].DebitPrice = PN.sliceNumber(price);
                temp[index].CreditPrice = "0";

            }
            else if (dataType == "CreditPrice") {
                var price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                temp[index].CreditPrice = PN.sliceNumber(price);
                temp[index].DebitPrice = "0";

            }

            if (dataType == "Acc_C" && value != undefined) {
                temp[index].Sub_Acc_Id1 = General.GuidEmpty();
                temp[index].Sub_Acc_Id2 = General.GuidEmpty();
                temp[index].Sub_Acc_Id3 = General.GuidEmpty();
                temp[index].Acc_GLId = General.GuidEmpty();
                temp[index].Acc_GId = General.GuidEmpty();
                temp[index].Sub_Acc_LCode1 = "";
                temp[index].Sub_Acc_LCode2 = "";
                temp[index].Sub_Acc_LCode3 = "";
                temp[index].Sub_Acc_LTitle1 = "";
                temp[index].Sub_Acc_LTitle2 = "";
                temp[index].Sub_Acc_LTitle3 = "";
                temp[index].Sub_Acc_LRemain1 = 0;
                temp[index].Sub_Acc_LRemain2 = 0;
                temp[index].Sub_Acc_LRemain2 = 0;

                temp[index].Acc_GLId = General.GuidEmpty();
                temp[index].Acc_GId = General.GuidEmpty();
                temp[index].Acc_GLTitle = "";
                temp[index].Acc_GTitle = "";
                temp[index].Acc_GLRemain = 0;
                temp[index].Acc_GRemain = 0;


                if (value.indexOf("|") > 1) {

                    temp[index].Acc_CId = value.split("|")[0];
                    temp[index].Acc_CTitle = value.split("|")[1];
                    temp[index].Acc_CCode = value.split("|")[2];
                    temp[index].Acc_CRemain = value.split("|")[3] * 1;
                    temp[index].Level1 = value.split("|")[4] * 1;
                    temp[index].Level2 = value.split("|")[5] * 1;
                    temp[index].Level3 = value.split("|")[6] * 1;
                    temp[index].Acc_GLId = value.split("|")[7];
                    temp[index].Acc_GLTitle = value.split("|")[8];
                    temp[index].Acc_GId = value.split("|")[9];
                    temp[index].Acc_GTitle = value.split("|")[10];
                    temp[index].Sub_Acc_L1 = temp[index].Level1;
                    temp[index].Sub_Acc_L2 = temp[index].Level2;
                    temp[index].Sub_Acc_L3 = temp[index].Level3;


                    SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level1 * 1)
                    SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level2 * 1)
                    SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level3 * 1)


                }
                else {
                    Auto_ACCCRef.current.Bind(value, General.GuidEmpty());
                    temp[index].Acc_CId = General.GuidEmpty();
                    temp[index].Acc_CTitle = value;
                    temp[index].Acc_CCode = "";
                    temp[index].Acc_CRemain = 0;
                    temp[index].Level1 = -1;
                    temp[index].Level2 = -1;
                    temp[index].Level3 = -1;
                    temp[index].Acc_GId = General.GuidEmpty();
                    temp[index].Acc_GTitle = "";
                    temp[index].Acc_GLId = General.GuidEmpty();
                    temp[index].Acc_GLTitle = "";
                    temp[index].Sub_Acc_L1 = -1;
                    temp[index].Sub_Acc_L2 = -1;
                    temp[index].Sub_Acc_L3 = -1;
                    setAcc_CTitle("")
                    setAcc_GTitle("")
                    setAcc_GLTitle("")
                    setSub_Acc_LTitle1("")
                    setSub_Acc_LTitle2("")
                    setSub_Acc_LTitle3("")
                    SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", -1)
                    SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", -1)
                    SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", -1)
                }




            }
            else if (dataType == "Sub1" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id1 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle1 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode1 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain1 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L1 = value.split("|")[4] * 1;
                    // return;
                }
                else {
                    temp[index].Sub_Acc_Id1 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle1 = value;
                    temp[index].Sub_Acc_LCode1 = "";
                    temp[index].Sub_Acc_LRemain1 = 0;
                    temp[index].Sub_Acc_L1 = temp[index].Level1;
                    setSub_Acc_LTitle1("")
                    SubLevelAccount1Ref.current.Bind(-1, value, temp[index].Level1)


                }
            }

            else if (dataType == "Sub2" && value != undefined) {
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id2 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle2 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode2 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain2 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L2 = value.split("|")[4] * 1;
                    // return;
                }
                else {
                    temp[index].Sub_Acc_Id2 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle2 = value;
                    temp[index].Sub_Acc_LCode2 = "";
                    temp[index].Sub_Acc_LRemain2 = 0;
                    temp[index].Sub_Acc_L2 = temp[index].Level2;
                    setSub_Acc_LTitle2("");
                    SubLevelAccount2Ref.current.Bind(-1, value, temp[index].Level2)


                }
            }
            else if (dataType == "Sub3" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id3 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle3 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode3 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain3 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L3 = value.split("|")[4] * 1;
                    // return;
                }
                else {
                    temp[index].Sub_Acc_Id3 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle3 = value;
                    temp[index].Sub_Acc_LCode3 = "";
                    temp[index].Sub_Acc_LRemain3 = 0;
                    temp[index].Sub_Acc_L3 = temp[index].Level3;
                    setSub_Acc_LTitle3("");
                    SubLevelAccount3Ref.current.Bind(-1, value, temp[index].Level3)


                }
            }


            else if (dataType == "Comment") {
                temp[index].Comment = value;
            }
            else if (dataType == "CommentFocus") {
                if (temp[index].Comment == "")
                    temp[index].Comment = Comment;
            }

            // setTotalCreditPrice(temp.map(o => o.CreditPrice).reduce((a, b) => a + b));
            // setTotalDebitPrice(temp.map(o => o.DebitPrice).reduce((a, b) => a + b));
            setItemList(temp);
        }
    }

    const Select_Item = (row, dataType, value) => {

        var temp = [...ItemList];

        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (dataType == "Acc_C" && value != undefined) {



                temp[index].Sub_Acc_Id1 = General.GuidEmpty();
                temp[index].Sub_Acc_Id2 = General.GuidEmpty();
                temp[index].Sub_Acc_Id3 = General.GuidEmpty();
                temp[index].Acc_GLId = General.GuidEmpty();
                temp[index].Acc_GId = General.GuidEmpty();
                temp[index].Sub_Acc_LCode1 = "";
                temp[index].Sub_Acc_LCode2 = "";
                temp[index].Sub_Acc_LCode3 = "";
                temp[index].Sub_Acc_LTitle1 = "";
                temp[index].Sub_Acc_LTitle2 = "";
                temp[index].Sub_Acc_LTitle3 = "";
                temp[index].Sub_Acc_LRemain1 = 0;
                temp[index].Sub_Acc_LRemain2 = 0;
                temp[index].Sub_Acc_LRemain2 = 0;

                temp[index].Acc_GLId = General.GuidEmpty();
                temp[index].Acc_GId = General.GuidEmpty();
                temp[index].Acc_GLTitle = "";
                temp[index].Acc_GTitle = "";
                temp[index].Acc_GLRemain = 0;
                temp[index].Acc_GRemain = 0;

                if (value.indexOf("|") > 1) {

                    temp[index].Acc_CId = value.split("|")[0];
                    temp[index].Acc_CTitle = value.split("|")[1];
                    temp[index].Acc_CCode = value.split("|")[2];
                    temp[index].Acc_CRemain = value.split("|")[3] * 1;
                    temp[index].Level1 = value.split("|")[4] * 1;
                    temp[index].Level2 = value.split("|")[5] * 1;
                    temp[index].Level3 = value.split("|")[6] * 1;
                    temp[index].Acc_GLId = value.split("|")[7];
                    temp[index].Acc_GLTitle = value.split("|")[8];
                    temp[index].Acc_GId = value.split("|")[9];
                    temp[index].Acc_GTitle = value.split("|")[10];

               
                    temp[index].Sub_Acc_L1 = temp[index].Level1;
                    temp[index].Sub_Acc_L2 = temp[index].Level2;
                    temp[index].Sub_Acc_L3 = temp[index].Level3;



                    setAcc_CTitle(value.split("|")[1] + "[" + value.split("|")[2] + "]")
                    setAcc_GTitle(value.split("|")[10])
                    setAcc_GLTitle(value.split("|")[8])



                    SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level1 * 1)
                    SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level2 * 1)
                    SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", temp[index].Level3 * 1)


                }
                else {
                    temp[index].Acc_CId = General.GuidEmpty();
                    temp[index].Acc_CTitle = value;
                    temp[index].Acc_CCode = "";
                    temp[index].Acc_CRemain = 0;
                    temp[index].Level1 = -1;
                    temp[index].Level2 = -1;
                    temp[index].Level3 = -1;
                    temp[index].Acc_GId = General.GuidEmpty();
                    temp[index].Acc_GTitle = "";
                    temp[index].Acc_GLId = General.GuidEmpty();
                    temp[index].Acc_GLTitle = "";
                    temp[index].Sub_Acc_L1 = -1;
                    temp[index].Sub_Acc_L2 = -1;
                    temp[index].Sub_Acc_L3 = -1;
                    SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", -1)
                    SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", -1)
                    SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", -1)
                }




            }
            else if (dataType == "Sub1" && value != undefined) {
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id1 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle1 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode1 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain1 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L1 = value.split("|")[4] * 1;
                    setSub_Acc_LTitle1(value.split("|")[1])
                }
                else {
                    temp[index].Sub_Acc_Id1 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle1 = value;
                    temp[index].Sub_Acc_LCode1 = "";
                    temp[index].Sub_Acc_LRemain1 = 0;
                    temp[index].Sub_Acc_L1 = temp[index].Level1;
                    SubLevelAccount1Ref.current.Bind(-1, value, temp[index].Level1)


                }
            }

            else if (dataType == "Sub2" && value != undefined) {
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id2 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle2 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode2 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain2 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L2 = value.split("|")[4] * 1;
                    setSub_Acc_LTitle2(value.split("|")[1])

                }
                else {
                    temp[index].Sub_Acc_Id2 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle2 = value;
                    temp[index].Sub_Acc_LCode2 = "";
                    temp[index].Sub_Acc_LRemain2 = 0;
                    temp[index].Sub_Acc_L2 = temp[index].Level2;

                    SubLevelAccount2Ref.current.Bind(-1, value, temp[index].Level2)


                }
            }
            else if (dataType == "Sub3" && value != undefined) {
                temp[index].ProductId = General.GuidEmpty();
                if (value.indexOf("|") > 1) {
                    temp[index].Sub_Acc_Id3 = value.split("|")[0];
                    temp[index].Sub_Acc_LTitle3 = value.split("|")[1];
                    temp[index].Sub_Acc_LCode3 = value.split("|")[2];
                    temp[index].Sub_Acc_LRemain3 = value.split("|")[3] * 1;
                    temp[index].Sub_Acc_L3 = value.split("|")[4] * 1;
                    setSub_Acc_LTitle3(value.split("|")[1])

                }
                else {
                    temp[index].Sub_Acc_Id3 = General.GuidEmpty();
                    temp[index].Sub_Acc_LTitle3 = value;
                    temp[index].Sub_Acc_LCode3 = "";
                    temp[index].Sub_Acc_LRemain3 = 0;
                    temp[index].Sub_Acc_L3 = temp[index].Level3;

                    SubLevelAccount3Ref.current.Bind(-1, value, temp[index].Level3)


                }
            }
        }
        setItemList(temp);
    }



    const SaveItem = (row) => {
        // setEdited(true);
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].DebitPrice == "0" && temp[index].CreditPrice == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("مبلغ اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].Acc_CId == General.GuidEmpty()) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب حساب معین اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].Sub_Acc_Id1 == General.GuidEmpty() && temp[index].Sub_Acc_L1 != -1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب حساب تفصیلی سطح 1 اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].Sub_Acc_Id2 == General.GuidEmpty() && temp[index].Sub_Acc_L2 != -1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب حساب تفصیلی سطح 2 اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].Sub_Acc_Id3 == General.GuidEmpty() && temp[index].Sub_Acc_L3 != -1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب حساب تفصیلی سطح 3 اجباری می باشد")), 'topCenter')
                return;
            }
            else {
                temp[index].status = "";

                temp[index].DebitPrice = temp[index].DebitPrice != "0" && temp[index].DebitPrice != 0 ? temp[index].DebitPrice.replaceAll(',', '') * 1 : 0;
                temp[index].CreditPrice = temp[index].CreditPrice != "0" && temp[index].CreditPrice != 0 ? temp[index].CreditPrice.replaceAll(',', '') * 1 : 0;

                if (temp.filter(item => item.Acc_CId == General.GuidEmpty()).length == 0)
                    temp.push({
                        row: ItemList.length + 1,
                        Acc_CId: General.GuidEmpty(),
                        Acc_CCode: '',
                        Acc_CTitle: '',
                        Acc_CRemain: 0,
                        Acc_GLId: General.GuidEmpty(),
                        Acc_GLCode: '',
                        Acc_GLTitle: '',
                        Acc_GLRemain: 0,
                        Acc_GId: General.GuidEmpty(),
                        Acc_GCode: '',
                        Acc_GTitle: '',
                        Acc_GRemain: 0,
                        Sub_Acc_Id3: General.GuidEmpty(),
                        Sub_Acc_L3: -1,
                        Level3: -1,
                        Sub_Acc_LCode3: '',
                        Sub_Acc_LTitle3: '',
                        Sub_Acc_LRemain3: 0,
                        Sub_Acc_Id2: General.GuidEmpty(),
                        Sub_Acc_L2: -1,
                        Level2: -1,
                        Sub_Acc_LCode2: '',
                        Sub_Acc_LTitle2: '',
                        Sub_Acc_LRemain2: 0,
                        Sub_Acc_Id1: General.GuidEmpty(),
                        Sub_Acc_L1: -1,
                        Level1: -1,
                        Sub_Acc_LCode1: '',
                        Sub_Acc_LTitle1: '',
                        Sub_Acc_LRemain1: 0,
                        Comment: Comment,
                        Id: General.GuidEmpty(),
                        status: "EDIT",
                        CreditPrice: 0,
                        DebitPrice: 0,
                        OrderShow: OrderShow * 1 + 1,
                    })
                setTotalCreditPrice(temp.map(o => o.CreditPrice).reduce((a, b) => a + b));
                setTotalDebitPrice(temp.map(o => o.DebitPrice).reduce((a, b) => a + b));
                setItemList(temp);
                setTimeout(() => {
                    Auto_ACCCRef.current.focus();

                    // const inputElement = document.querySelector('.FocusItem');
                    // if (inputElement) {
                    //     inputElement.focus();
                    // }
                }, 200)
            }

        }


    }

    const DeleteItem = (row) => {

        // setEdited(true);
        var temp = [...ItemList.filter(item => item.row !== row)];
        setItemList(temp);
        if (temp.length > 0) {

            setTotalCreditPrice(temp.map(o => o.CreditPrice).reduce((a, b) => a + b));
            setTotalDebitPrice(temp.map(o => o.DebitPrice).reduce((a, b) => a + b));

        }
        else {

            setTotalCreditPrice(0);
            setTotalDebitPrice(0);

        }
        const inputElement = document.querySelector('.FocusBtn');
        if (inputElement) {
            inputElement.focus();
        }


    }

    const CheckPermission = () => {

        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 33);
        myHeaders.append("Operation", HeaderId != General.GuidEmpty() ? 3 : 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("DocHeaderId") != undefined && localStorage.getItem("DocHeaderId") != General.GuidEmpty()) {
                            GetById(localStorage.getItem("DocHeaderId"));
                            setHeaderId(localStorage.getItem("DocHeaderId"))
                        }
                        else {
                            NewItem();
                            DocTypeRef.current.Bind(-1)

                        }


                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e) => {
        if (e.key == "Enter") {

            if ([...ItemList].length > 0) {
                var index = [...ItemList].findIndex(x => x.status == "EDIT");
                if (index != -1) {
                    SaveItem([...ItemList][index].row);
                    return;
                }
                else {
                    NewItem();
                    return;

                }
            }
            else {
                NewItem();
            }
        }
        if (e.key == "Delete") {
            var index = [...ItemList].findIndex(x => x.status == "EDIT");

            if (index != -1)
                DeleteItem([...ItemList][index].row);
            else if ([...ItemList].length > 0)
                DeleteItem([...ItemList][[...ItemList].length - 1].row);
        }


        if (e.key == "Escape") {
            localStorage.removeItem("DocHeaderId");
            navigate("/DocIndex")
        }

        if (e.shiftKey && e.code === "KeyS") {
            Save();
        }
        if (e.shiftKey && e.code === 'KeyP' && HeaderId != General.GuidEmpty()) {
            Print();
        }
        if (e.shiftKey && e.code === 'KeyN') {
            Reset();
        }
    }

    const Print = () => {
        navigate("/DocPrintIndex")
    }

    useEffect(() => {
        CheckPermission();
        document.title = "ثبت سند حسابداری";
    }, [])
    //#endregion



    return (

        <Layout title="ثبت سند حسابداری ">
            <div className="h-100 p-1" onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" disabled={TotalCreditPrice != TotalDebitPrice && State == 1 ? true : false} className="m-1" onClick={() => Save(State)}> {State == 0 ? <>ثبت پبش نویس</> : <>ثبت</>}  </rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className={localStorage.getItem("DocHeaderId") != General.GuidEmpty() ? "m-1" : 'hide'} onClick={() => Print()}> پرینت</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={Reset}>  جـــدید</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (localStorage.removeItem("DocHeaderId"), navigate("/DocIndex"))}>  بازگشت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>


                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>شماره سند</label>
                            <rsuite.Input disabled value={SystemNumber} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>سریال سند</label>
                            <rsuite.Input disabled value={SerialNo} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>عطف سند</label>
                            <rsuite.Input value={Number} onChange={(e) => setNumber(e)} className='FirstFocus' />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> تاریخ </label>
                            <DatePicker className="rs-input " isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={RegisterDate} onChange={RegisterDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label>نوع </label>
                            <Drp_DocType value={DocTypeId} onChange={(e) => setDocTypeId(2)} ref={DocTypeRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24}>
                            <label> وضعیت سند </label>
                            <select className="rs-input" onChange={(e) => setState(e.target.value)} value={State}>
                                <option value="0">پبش نویس </option>
                                <option value="1">موقت  </option>
                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> شرح سند</label>
                            {/* , setEdited(true) */}
                            <rsuite.Input value={Comment} onChange={(e) => (setComment(e))} />
                        </rsuite.Col>


                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1 mb-5 pb-5" >
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button className='FocusBtn' appearance="primary" color="green" size='xs'
                                onClick={() => NewItem()}>
                                اضافه کردن سطر جدید
                            </rsuite.Button>
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                            <rsuite.Table height={320} data={ItemList} rowHeight={80} wordWrap>
                                <rsuite.Table.Column width={50} align="center"  >
                                    <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell dataKey="row">
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                                <rsuite.Table.Column flexGrow={2} fullText resizable>
                                    <rsuite.Table.HeaderCell> معین</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >

                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (


                                                    <Auto_ACCC className="rs-input" value={rowData.Acc_CTitle}
                                                        onChange={value => { Change_Item?.(rowData.row, "Acc_C", value); }}
                                                        onSelect={value => { Select_Item?.(rowData.row, "Acc_C", value); }}
                                                        // onKeyUp={value => ItemOnKeyUp(value, rowData.row)}

                                                        ref={Auto_ACCCRef} />

                                                ) : (
                                                    <text>
                                                        {rowData.Acc_CTitle}
                                                    </text>
                                                )}
                                            </>
                                        }}

                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={250} >
                                    <rsuite.Table.HeaderCell>تفصیلی 1 </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >



                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (


                                                    <Auto_SubLevelAccount1 className="rs-input" value={rowData.Sub_Acc_LTitle1}
                                                        onChange={value => { Change_Item?.(rowData.row, "Sub1", value); }}
                                                        onSelect={value => { Select_Item?.(rowData.row, "Sub1", value); }}
                                                        ref={SubLevelAccount1Ref} />

                                                ) : (
                                                    <text>
                                                        {rowData.Sub_Acc_LTitle1}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>



                                </rsuite.Table.Column>


                                <rsuite.Table.Column width={250} >
                                    <rsuite.Table.HeaderCell>تفصیلی 2 </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >



                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (


                                                    <Auto_SubLevelAccount2 className="rs-input" value={rowData.Sub_Acc_LTitle2}
                                                        onChange={value => { Change_Item?.(rowData.row, "Sub2", value); }}
                                                        onSelect={value => { Select_Item?.(rowData.row, "Sub2", value); }}
                                                        ref={SubLevelAccount2Ref} />

                                                ) : (
                                                    <text>
                                                        {rowData.Sub_Acc_LTitle2}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>

                                <rsuite.Table.Column width={250} >
                                    <rsuite.Table.HeaderCell>تفصیلی 3 </rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >



                                        {(rowData) => {
                                            return <>

                                                {rowData.status == 'EDIT' ? (


                                                    <Auto_SubLevelAccount3 className="rs-input" value={rowData.Sub_Acc_LTitle3}
                                                        onChange={value => { Change_Item?.(rowData.row, "Sub3", value); }}
                                                        onSelect={value => { Select_Item?.(rowData.row, "Sub3", value); }}
                                                        ref={SubLevelAccount3Ref} />

                                                ) : (
                                                    <text>
                                                        {rowData.Sub_Acc_LTitle3}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>



                                <rsuite.Table.Column flexGrow={2} >
                                    <rsuite.Table.HeaderCell>مبلغ بدهکار (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={rowData.DebitPrice} onChange={value => {
                                                            Change_Item?.(rowData.row, "DebitPrice", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.DebitPrice != "0" ? <>{PN.convert(rowData.DebitPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.DebitPrice)}
                                                        <br />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.DebitPrice != "0" ? <>{PN.convert(rowData.DebitPrice)} ریال</> : ""}</rsuite.Text>

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>

                                <rsuite.Table.Column flexGrow={2} >
                                    <rsuite.Table.HeaderCell>مبلغ بستانکار (ریال)</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell >
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <>

                                                        <rsuite.Input value={rowData.CreditPrice} onChange={value => {
                                                            Change_Item?.(rowData.row, "CreditPrice", value);
                                                        }}

                                                        />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.CreditPrice != "0" ? <>{PN.convert(rowData.CreditPrice.replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                                    </>

                                                ) : (
                                                    <text>
                                                        {PN.sliceNumber(rowData.CreditPrice)}
                                                        <br />
                                                        <rsuite.Text className='Font10 float-start' as='sub'>{rowData.CreditPrice != "0" ? <>{PN.convert(rowData.CreditPrice)} ریال</> : ""}</rsuite.Text>

                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>





                                <rsuite.Table.Column flexGrow={2} >
                                    <rsuite.Table.HeaderCell> شرح</rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>
                                                {rowData.status == 'EDIT' ? (
                                                    <rsuite.Input value={rowData.Comment}
                                                        onChange={value => { Change_Item?.(rowData.row, "Comment", value); }}
                                                        onFocus={value => { Change_Item?.(rowData.row, "CommentFocus"); }}
                                                    />
                                                ) : (
                                                    <text>
                                                        {rowData.Comment}
                                                    </text>
                                                )}
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>

                                <rsuite.Table.Column width={100} fixed='right'>
                                    <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                    <rsuite.Table.Cell>
                                        {(rowData) => {
                                            return <>


                                                {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                    :
                                                    <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                }
                                                &nbsp;&nbsp;&nbsp;
                                                <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                            </>
                                        }}
                                    </rsuite.Table.Cell>
                                </rsuite.Table.Column>
                            </rsuite.Table>



                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1   pt-5 mt-5 '>

                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <rsuite.Row>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>گروه : </label>&nbsp;&nbsp;
                                    <b>{Acc_GTitle} - {Acc_GRemain}</b>
                                </rsuite.Col>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>کل : </label>&nbsp;&nbsp;
                                    <b>{Acc_GLTitle} - {Acc_GLRemain}</b>
                                </rsuite.Col>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>معین : </label>&nbsp;&nbsp;
                                    <b>{Acc_CTitle} - {Acc_CRemain}</b>
                                </rsuite.Col>



                            </rsuite.Row>
                        </rsuite.Col>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <rsuite.Row>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>تفصیلی 1 : </label>&nbsp;&nbsp;
                                    <b>{Sub_Acc_LTitle1}</b>
                                </rsuite.Col>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>تفصیلی 2 : </label>&nbsp;&nbsp;
                                    <b>{Sub_Acc_LTitle2}</b>
                                </rsuite.Col>
                                <rsuite.Col xxl={13} xl={13} lg={13} md={13} sm={24} xs={24} className='mt-2'>
                                    <label>تفصیلی 3 : </label>&nbsp;&nbsp;
                                    <b>{Sub_Acc_LTitle3}</b>
                                </rsuite.Col>



                            </rsuite.Row>
                        </rsuite.Col>



                    </rsuite.Row>
                    <rsuite.Row className='p-1   pt-5 mt-5 '>

                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='alert alert-success p-2'>
                            <p><b>بستانکار : </b> {PN.sliceNumber((TotalCreditPrice))} ریال
                                &nbsp;&nbsp;&nbsp;&nbsp; <b>{PN.convert((TotalCreditPrice).toString())} ریال</b>
                            </p>
                        </rsuite.Col>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='alert alert-danger p-2 '>
                            <p> <b>بدهکار :</b> {PN.sliceNumber((TotalDebitPrice))} ریال
                                &nbsp;&nbsp;&nbsp;&nbsp; <b>{PN.convert((TotalDebitPrice).toString())} ریال</b>
                            </p>
                        </rsuite.Col>



                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن سطر جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف سطر
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+s :</b> ثبت نهایی
                                <b>| Shift+p :</b> ثبت نهایی و پرینت
                                <b>| Shift+N :</b> جدید
                            </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel>
            </div >



        </Layout >

    )
}

export default InsertDocIndex;